module.exports = __webpack_public_path__ + "img/identify2.dde93a61.png";